import React, {useContext} from 'react';


import './ModalMenu.css';
import './GearButton.css';

import Modal from '../modal/Modal';
import Ajuda from './ajuda/Ajuda';
import Compartilhar from './compartilhar/Compartilhar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTimesCircle, faVolumeUp, faVolumeMute} from '@fortawesome/free-solid-svg-icons';
import {ContextGlobal} from '../globalProvider';

const Config = () => {

	const {state, dispatch} = useContext(ContextGlobal);

	const handleClickOpen = () => {
		dispatch({type:"UpdateConfig"});
	};

	const handleSound = () => {
		dispatch({type:"UpdateSound"});
	};

	const soundButton = (state.sound) ?	
		<FontAwesomeIcon className="" icon={faVolumeUp} />:
			<FontAwesomeIcon className="" icon={faVolumeMute} ></FontAwesomeIcon>;
	
	const openButton = <div className="contentGearButton backgroundEIC column centerItens spaceAroundContent">
							<FontAwesomeIcon className = "gearButton backgoundEIC" icon = {faCog} onClick={handleClickOpen}/>
						</div>;

	return (
		<Modal button={openButton} visible={state.config}>
			<div className = "modalMenu column centerItens space ">
				<div className="head row nowrap spaceBetweenContent centerItens">
					<div className="title colorEIC row">Menu</div>
					<div className = "close colorEIC shadow column spaceAroundContent centerItens startItens">
						<FontAwesomeIcon className="" icon = {faTimesCircle} onClick = {handleClickOpen} />
					</div>
				</div>
				<div className="content column spaceAroundContent">
					<div className="button shadow backgroundEIC row nowrap centerItens" onClick = {handleSound}>
						<div className="icon">
							{soundButton}
						</div>
						<div className="name">
							Música
						</div>
					</div>
					<div className="button shadow backgroundEIC"><Compartilhar /></div>
					<div className="button shadow backgroundEIC "><Ajuda /></div>
				</div>
			</div>
		</Modal>
	);
};

export default Config;